import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (
      command: 'event' | 'config' | 'js',
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
    GA_MEASUREMENT_ID?: string;
  }
}

/**
 * Google Analytics 페이지뷰 자동 추적 훅
 */
export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function' && window.GA_MEASUREMENT_ID) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
}

/**
 * 커스텀 이벤트 전송 헬퍼 함수
 */
export function trackEvent(
  eventName: string,
  eventParams?: Record<string, unknown>
) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * 주요 사용자 행동 이벤트 전송 함수들
 */
export const GAEvents = {
  // 로그인 성공
  login: (method: 'google' | 'github') => {
    trackEvent('login', {
      method,
    });
  },

  // 게시글 작성
  createPost: (category: string) => {
    trackEvent('create_post', {
      category,
    });
  },

  // 좋아요 클릭
  likePost: (postId: string) => {
    trackEvent('like_post', {
      post_id: postId,
    });
  },

  // 댓글 작성
  createComment: (postId: string) => {
    trackEvent('create_comment', {
      post_id: postId,
    });
  },

  // 검색 실행
  search: (searchTerm: string) => {
    trackEvent('search', {
      search_term: searchTerm,
    });
  },

  // 프로필 수정
  updateProfile: () => {
    trackEvent('update_profile');
  },

  // 채용공고 작성
  createJob: () => {
    trackEvent('create_job');
  },
};
